export default [
  {
    formFields: [
      {
        title: 'Name',
        type: 'text',
        property: 'title',
        value: '',
        counter: 150,
        rules: [(v) => !!v || 'Name is required', (v) => v.length <= 150 || 'Name must be 150 characters or less'],
        required: true
      },
      {
        title: 'Description',
        type: 'textarea',
        property: 'description',
        value: '',
        counter: 400,
        rules: [(v) => v.length <= 400 || 'Description must be 400 characters or less']
      },
      {
        title: 'URL',
        type: 'text',
        property: 'url',
        value: '',
        rules: [(v) => !!v || 'URL is required', (v) => v.endsWith('.m3u8') || 'Stream URL should be in .m3u8 format'],
        required: true
      },
    ]
  }
];
